import { useFocusableGroup, useTabsterAttributes } from '@fluentui/react-tabster';

export const useMessageAttributes = ({
  contentId,
  headingId,
  defaultFocused,
}: {
  contentId: string;
  headingId: string;
  defaultFocused?: boolean;
}): {
  'data-tabster': string | undefined;
  role: string;
  tabIndex: number;
  'aria-labelledby': string;
} => {
  // Initialize groupper
  useFocusableGroup();

  const accessibleProps = {
    role: 'article',
    tabIndex: 0,
    'aria-labelledby': `${headingId} ${contentId}`,
  };

  const tabsterProps = useTabsterAttributes({
    groupper: { tabbability: 2 /*limitedTrapFocus*/ },
    focusable: { isDefault: defaultFocused },
  });

  return { ...accessibleProps, ...tabsterProps };
};
